import { cxTheme } from 'components/storybook-migration/theme-provider/system-design/theme';
import { TooltipContent } from 'components/Tooltip/Tooltip.styled';
import { SPACING_3, SPACING_4 } from 'constants/theme-constants';
import styled from 'styled-components';

export const MIN_TOOLTIP_WIDTH = 270;

export const ChartTooltipStyled = styled(TooltipContent)`
  ${({ theme }) => `
    pointer-events: none;
    display: flex;
    visibility: none;
    flex-direction: column;
    min-width: ${MIN_TOOLTIP_WIDTH}px;
    min-height: 140px;
    padding: ${cxTheme.spacing[SPACING_3]};
    position: absolute;
    top: ${cxTheme.spacing[SPACING_4]};
    z-index: ${cxTheme.zIndex[3]};
  `}
`;

export const ChartTooltipHeader = styled.h2`
  ${({ theme }) => `
    margin-bottom: ${cxTheme.spacing[SPACING_4]};
    ${theme.label.small.normal}
  `}
`;

export const SunIconWrapper = styled.span`
  color: ${({ theme }) => {
    return theme.accent.primary.strong;
  }};
  margin-right: 2px;
  display: flex;
`;
